module.exports = __webpack_public_path__ + "img/topic_bg_image.0b3c281.png";